<template>
  <div style="height: 100%;background-color: white;padding: 20px;box-sizing: border-box;overflow-y: auto">
    <div style="height: 50px">
      <span>分组显示模式：</span>
      <el-radio-group v-model="labelval" @change="changePage">
        <el-radio-button :label="0">服务商</el-radio-button>
        <el-radio-button :label="1">服务内容</el-radio-button>
      </el-radio-group>&nbsp;
      <el-button type="primary" plain icon="el-icon-plus" @click="addSupplier()">新建服务商</el-button>
      <el-button type="primary" plain icon="el-icon-plus" @click="addContentSupplier()">服务商绑定服务内容</el-button>
    </div>
    <div v-if="labelval === 0" style="max-height: calc(100% - 100px);overflow-y: auto">
      <el-table v-if="labelval === 0" v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="tableData0" border style="width: 100%"
                highlight-current-row ref="single">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table style="width: 96%;margin: auto"  size="small" border :data="props.row.childData0" :header-cell-style="{backgroundColor: '#e8f0fa', color: '#696969'}">
              <el-table-column prop="service_name" label="服务内容" min-width="90" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.service_name}}</span>
                </template>
              </el-table-column>
              <el-table-column label="服务类型" min-width="100" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.st_id !== 0">{{getUpTypeName(scope.row.st_id)}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="time_duration" label="服务时长(分钟)" min-width="90" align="center"></el-table-column>
              <el-table-column label="服务价格" min-width="70" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.price !== ''">{{parseFloat(scope.row.price) / 100}}元</span>
                </template>
              </el-table-column>
<!--              <el-table-column label="发起服务扩展字段" min-width="140" align="center">-->
<!--                <template slot-scope="scope">-->
<!--                  <el-tag v-if="scope.row.service_requirements_tag === 1" v-for="(item, index) in scope.row.servicerequirements[0]" :key="index">{{item.key}}</el-tag>-->
<!--                </template>-->
<!--              </el-table-column>-->
<!--              <el-table-column label="确认服务扩展字段" min-width="140" align="center">-->
<!--                <template slot-scope="scope">-->
<!--                  <el-tag v-if="scope.row.service_requirements_tag === 1" v-for="(item, index) in scope.row.servicerequirements[1]" :key="index">{{item.key}}</el-tag>-->
<!--                </template>-->
<!--              </el-table-column>-->
<!--              <el-table-column label="确认服务照片类型" min-width="140" align="center">-->
<!--                <template slot-scope="scope">-->
<!--                  <el-tag v-if="scope.row.picture_requirements_tag === 1" v-for="(item, index1) in scope.row.picturerequirements" :key="index1">{{item.key}}</el-tag>-->
<!--                </template>-->
<!--              </el-table-column>-->
              <el-table-column align="center" label="操作" width="120"  class-name="small-padding fixed-width">
                <template slot-scope="scope">
                  <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editContentSupplier(scope.row)"></i>
                  <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delContentSupplier(scope.row)"></i>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="服务商" min-width="90" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属组织"  min-width="100" align="center">
          <template slot-scope="scope">
            <span>{{getOnOrg(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="地址" min-width="160" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.address}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="telephone" label="电话号码" min-width="90" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.telephone}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contact_person" label="联系人" min-width="90" align="center"></el-table-column>
        <el-table-column prop="contact_telephone" label="联系人号码" min-width="90" align="center"></el-table-column>
        <el-table-column prop="" label="营业执照" min-width="90" align="center">
          <template slot-scope="scope">
            <img v-if="scope.row.business_license !== ''" style="width: 80px;height: 60px;cursor: pointer"
                 :src="scope.row.business_license" @click="showImage(scope.row, scope.row.business_license)"/>
          </template>
        </el-table-column>
        <el-table-column prop="" label="二维码" min-width="90" align="center">
          <template slot-scope="scope">
            <img v-if="scope.row.codeUrl !== ''" style="width: 80px;height: 60px;cursor: pointer"
                 :src="scope.row.codeUrl" @click="showImage(scope.row, scope.row.codeUrl)"/>
          </template>
        </el-table-column>
        <el-table-column label="绑定服务内容数量" min-width="130" align="center">
          <template slot-scope="scope">
            <strong style="color: #1a1a1a">{{scope.row.childData0.length}}</strong>&nbsp;
            <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="addContentSupplier(scope.row)"></el-button>
          </template>
        </el-table-column>
        <el-table-column prop="modify_time" label="修改时间" min-width="110" align="center"></el-table-column>
        <el-table-column align="center" label="操作" width="80"  class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editSupplier(scope.row)"></i>
            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delSupplier(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="labelval === 1" style="max-height: calc(100% - 100px);overflow-y: auto">
      <el-table v-if="labelval === 1" v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="tableData1" border style="width: 100%"
                highlight-current-row ref="singleTable">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table style="width: 96%;margin: auto"  size="small" border :data="props.row.childData1" :header-cell-style="{backgroundColor: '#e8f0fa', color: '#696969'}">
              <el-table-column prop="name" label="服务商" min-width="90" align="center"></el-table-column>
              <el-table-column prop="address" label="地址" min-width="160" align="center"></el-table-column>
              <el-table-column prop="telephone" label="电话号码" min-width="90" align="center"></el-table-column>
              <el-table-column label="服务时长(分钟)" min-width="90" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.time_duration !== ''">{{ scope.row.time_duration }} 分钟</span>
                </template>
              </el-table-column>
              <el-table-column label="服务价格" min-width="100" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.price !== ''">{{parseFloat(scope.row.price) / 100}}元</span>
                </template>
              </el-table-column>
<!--              <el-table-column align="center" label="操作" width="120"  class-name="small-padding fixed-width">-->
<!--                <template slot-scope="scope">-->
<!--                  <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editContentSupplier(scope.row)"></i>-->
<!--                  <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delContentSupplier(scope.row)"></i>-->
<!--                </template>-->
<!--              </el-table-column>-->
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="typename" label="服务内容" min-width="90" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.typename}}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务类型" min-width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.upid !== 0">{{getUpTypeName(scope.row.upid)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务商数量" min-width="130" align="center">
          <template slot-scope="scope">
            <strong style="color: #1a1a1a">{{scope.row.childData1.length}}</strong>&nbsp;
            <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="bindSupplier(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height:40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
      </el-pagination>
    </div>
    <!--服务商 created update-->
    <el-dialog :visible.sync="addEditSupplierShow" v-if="addEditSupplierShow" width="700px" :show-close="true"
               :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>{{openTitle0}}</span></div>
        <div class="line-title"></div>
      </div>
      <add-edit-service :addEdit="addEditSupplier" v-model="addEditSupplierShow" @updateTableSupp="changeUpadte0"></add-edit-service>
    </el-dialog>
    <!--服务内容 created update-->
    <el-dialog :visible.sync="addEditContentShow" v-if="addEditContentShow"
               width="600px" :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>{{openTitle1}}</span></div>
        <div class="line-title"></div>
      </div>
      <add-edit-scontent :addEdit="addEditContent" v-model="addEditContentShow" @changeUpadte="changeUpadte"></add-edit-scontent>
    </el-dialog>
    <!--查看原图-->
    <el-dialog :visible.sync="imagePreview.visible" v-if="imagePreview.visible" width="800px" center class="all-open">
      <div style="width: 100%;text-align: center;padding: 10px">
        <div style="height: 40px;font-size: 18px;line-height: 50px">{{imagePreview.row.name}}</div>
        <img :src="imagePreview.url" style="max-width: 100%" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qrcode from 'qrcode'
import {
  deletesupplierorg, deletesupplierservice,
  querysupplierorgbystid,
  querysupplierorgnotype,
  querysupplierservice,
  querysuppliertype
} from '../../api/serviceMark'
import {queryorg} from '../../api/organizer'
import addEditService from './childComponents/addEditService'
import addEditScontent from '../servicemanagement/childComponents/addEditScontent'
export default {
  name: 'supplierType',
  components: {addEditService, addEditScontent},
  data () {
    return {
      loading: true,
      orgData: [],
      types: [], // 服务类型
      labelval: 0,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      allSupplier: [], // 全部服务商
      allService: [], // 全部服务内容
      tableData0: [], // 服务商
      openTitle0: '',
      addEditSupplierShow: false,
      addEditSupplier: {
        isAdd: true,
        row: {},
        orgData: [],
        types: []
      },
      supplierChild: [], // 服务商子表数据
      allTypeService: [], // 全部舒服类型中的服务内容
      tableData1: [], // 服务内容
      openTitle1: '',
      addEditContentShow: false,
      addEditContent: {
        isAdd: true,
        isService: false, // 是否为具体服务商绑定服务内容
        supplierId: '', // 服务商id
        serviceRow: '', // 服务内容
        orgid: '',
        allSupplier: [],
        types: [],
        orgData: [],
        row: {},
        childData: [] // 具体服务商下所绑定服务内容
      },
      imagePreview: {
        row: {},
        visible: false,
        url: ''
      }
    }
  },
  created () {
    this.golobleObject.updateTableSupp = this.getTableData0
    this.getOrgData()
  },
  methods: {
    showImage (row, url) {
      this.imagePreview.row = row
      this.imagePreview.url = url
      this.imagePreview.visible = true
    },
    changeUpadte () {
      this.addEditContentShow = false
      this.querySupplierTypeData()
    },
    changeUpadte0 () {
      this.getAllTable0()
    },
    // 组织
    getOrgData () {
      this.loading = true
      queryorg().then(res => {
        this.orgData = res.data.org
        this.addEditSupplier.orgData = this.orgData
        this.querySupplierTypeData()
      }).catch(() => {
        this.loading = false
      })
    },
    // 服务类型
    querySupplierTypeData () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        orgid: []
      }
      let typeids = []
      querysuppliertype(params, data).then(res => {
        this.addEditSupplier.types = res.data.types
        this.types = res.data.types
        this.addEditContent.types = res.data.types
        this.allTypeService = res.data.types.filter(item => {
          if (item.is_service === 1) {
            typeids.push(item.id)
            return true
          }
        })
        this.getAllTable0()
        this.getSupplierChild(typeids)
      }).catch(() => {
        this.loading = false
      })
    },
    // 服务商（子表）
    getSupplierChild (ids) {
      if (ids.length === 0) {
        return
      }
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        st_ids: ids
      }
      querysupplierorgbystid(params, data).then(res => {
        this.supplierChild = res.data.org
      }).catch(() => {})
    },
    // 全部服务商
    async getAllTable0 () {
      this.loading = true
      let params = {
        page: 1,
        size: 99999
      }
      querysupplierorgnotype(params).then(async res => {
        this.loading = false
        let arr = []
        for (let i = 0; i < res.data.org.length; i++) {
          let obj = res.data.org[i]
          obj.codeUrl = await this.generateQRCode(obj.uuid)
          arr.push(obj)
        }
        this.allSupplier = arr
        this.addEditContent.allSupplier = arr
        this.getAllTable1()
      }).catch(() => {
        this.loading = false
      })
    },
    async generateQRCode (uuid) {
      if (uuid === '') {
        return ''
      }
      // let code = uuid
      let code = 'https://kangnh.com/invitecode?code=' + uuid
      try {
        // 使用qrcode.toDataURL()生成二维码的URL
        return await qrcode.toDataURL(code)
      } catch (err) {
        console.error('生成二维码失败:', err)
        return ''
      }
    },
    // 全部服务内容(子表)
    getAllTable1 () {
      let params = {
        page: 1,
        size: 99999
      }
      querysupplierservice(params).then(res => {
        this.loading = false
        let arr = []
        for (let i = 0; i < res.data.service.length; i++) {
          let obj = res.data.service[i]
          obj.servicerequirements = []
          obj.picturerequirements = []
          if (obj.service_requirements_tag === 1) {
            try {
              obj.servicerequirements = JSON.parse(obj.service_requirements)
            } catch (error) {
            }
          }
          if (obj.picture_requirements_tag === 1) {
            try {
              obj.picturerequirements = JSON.parse(obj.picture_requirements)
            } catch (error) {
            }
          }
          arr.push(obj)
        }
        this.allService = arr
        if (this.labelval === 0) {
          this.getTableData0()
        } else {
          this.getTableData1()
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 切换页面展示
    changePage () {
      this.totalCells = 0
      this.pageSize = 10
      this.currentPage = 1
      this.tableData0 = []
      this.tableData1 = []
      if (this.labelval === 0) {
        this.getTableData0()
      } else {
        this.getTableData1()
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      if (this.labelval === 0) {
        this.getTableData0()
      } else {
        this.getTableData1()
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.labelval === 0) {
        this.getTableData0()
      } else {
        this.getTableData1()
      }
    },
    addSupplier () {
      this.openTitle0 = '新建服务商'
      this.addEditSupplier.isAdd = true
      this.addEditSupplier.row = ''
      this.addEditSupplierShow = true
    },
    editSupplier (row) {
      this.openTitle0 = '更新服务商'
      this.addEditSupplier.isAdd = false
      this.addEditSupplier.row = row
      this.addEditSupplierShow = true
    },
    delSupplier (row) {
      let name = row.name
      this.$confirm('此操作将永久删除该服务商【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          soids: [row.id]
        }
        deletesupplierorg(data).then(res => {
          if (this.tableData0.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.getAllTable0()
          this.$notify({
            title: '成功',
            message: '删除服务商成功',
            type: 'success',
            duration: 2000
          })
        }).catch(() => {})
      }).catch(() => {})
    },
    // 获取服务商表格
    getTableData0 () {
      console.log(88, this.allSupplier)
      let arr = this.clone(this.allSupplier)
      let arr1 = []
      for (let i = (this.currentPage - 1) * this.pageSize; i < this.currentPage * this.pageSize; i++) {
        if (!arr[i]) {
          break
        }
        let obj = arr[i]
        obj.childData0 = this.allService.filter(value => {
          if (value.so_id === obj.id) {
            return true
          }
        })
        arr1.push(arr[i])
      }
      this.tableData0 = arr1
      this.totalCells = arr.length
    },
    getUpTypeName (upid) {
      let name = ''
      let upids = this.getOrgName1(parseInt(upid), [])
      for (let i = 0; i < upids.length; i++) {
        for (let j = 0; j < this.types.length; j++) {
          if (parseInt(upids[i]) === this.types[j].id) {
            name = this.types[j].typename + ' / ' + name
          }
        }
      }
      return name !== '' ? name.substring(0, name.length - 3) : ''
    },
    getOrgName1 (upid, arr) {
      arr.push(upid)
      for (let i = 0; i < this.types.length; i++) {
        if (parseInt(upid) === this.types[i].id) {
          arr = this.getOrgName1(this.types[i].upid, arr)
        }
      }
      return arr
    },
    addContentSupplier (row) {
      console.log(row)
      if (row) {
        this.openTitle1 = '【' + row.name + '】绑定服务内容'
        this.addEditContent.supplierId = row.id
        this.addEditContent.orgid = row.orgid
        this.addEditContent.isService = true
        this.addEditContent.childData = row.childData0
      } else {
        this.openTitle1 = '服务商绑定服务内容'
        this.addEditContent.supplierId = ''
        this.addEditContent.orgid = ''
        this.addEditContent.isService = false
        this.addEditContent.childData = []
      }
      this.addEditContent.serviceRow = ''
      this.addEditContent.isAdd = true
      this.addEditContent.row = ''
      this.addEditContentShow = true
    },
    bindSupplier (row) {
      this.openTitle1 = '服务商绑定服务内容'
      this.addEditContent.isService = false
      this.addEditContent.supplierId = ''
      this.addEditContent.orgid = ''
      this.addEditContent.serviceRow = row
      this.addEditContent.isAdd = true
      this.addEditContent.row = ''
      this.addEditContentShow = true
    },
    editContentSupplier (row) {
      this.openTitle1 = '更新绑定服务内容'
      this.addEditContent.isAdd = false
      this.addEditContent.row = this.clone(row)
      this.addEditContentShow = true
    },
    delContentSupplier (row) {
      let vm = this
      this.$confirm('此操作将永久删除该【' + row.service_name + '】服务内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id,
          so_id: row.so_id,
          st_id: row.st_id
        }
        deletesupplierservice(data).then(res => {
          vm.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
          if (vm.tableData1.length === 1 && vm.currentPage > 1) {
            vm.currentPage--
          }
          vm.getAllTable1()
        }).catch(() => {})
      }).catch(() => {})
    },
    // 获取服务内容表格
    getTableData1 () {
      let arr = this.clone(this.allTypeService)
      let arr1 = []
      for (let i = (this.currentPage - 1) * this.pageSize; i < this.currentPage * this.pageSize; i++) {
        if (!arr[i]) {
          break
        }
        let obj = arr[i]
        obj.childData1 = this.supplierChild.filter(value => {
          if (value.typeid === obj.id) {
            return true
          }
        })
        arr1.push(arr[i])
      }
      this.tableData1 = arr1
      this.totalCells = arr.length
    },
    getOnOrg (row) {
      for (let i = 0; i < this.orgData.length; i++) {
        if (row.orgid === this.orgData[i].id) {
          return this.orgData[i].name
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/serviceprovider/supplierType.vue